import React, { FC, Fragment, useEffect } from "react";

import { ReactCookieProps, withCookies } from "react-cookie";
import _ from "lodash";
import { Props } from "../propTypes";
import { childFormComponent } from "./types";

const Success: FC<Props & childFormComponent & ReactCookieProps> = (props) => {
    useEffect(() => {
        document.body.classList.add("success-screen");

        if (props.cookies) {
            props.cookies.remove(
                "confirmation_" + props.registrationType.toLowerCase(),
                { path: "/" }
            );
        }
    }, [props.cookies, props.registrationType]);

    if (props.renderSuccess && _.isFunction(props.renderSuccess)) {
        return <Fragment>{props.renderSuccess()}</Fragment>;
    }
    return null;
};

export default withCookies(Success);
